export const ERROR_REQUIRED_FIELD = 'This field is required';
export const ERROR_INVALID_EMAIL = 'Please enter a valid company email address (@stengg.com)';
export const ERROR_INCORRECT_EMAIL_PASSWORD = 'Incorrect Email or Password. Please try again!';
export const ERROR_MAX_LENGTH = (max: number) =>
  `This field must be at most ${max} characters long`;
export const ERROR_INVALID_FORMAT = 'This format is invalid.';
export const ERROR_OFFICE_MANAGER_EMAIL =
  'This email is not associated with an active Office Manager account.';
export const ERROR_FILE_NAME_INVALID =
  'File name contains invalid characters. Only letters, numbers, spaces, hyphens, underscores, and periods are allowed.';
export const ERROR_UNEXPECTED = 'An unexpected error occurred.';
